import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const UVKitsPage: React.FC = () => {
  return (
    <main className="container py-4">
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h2>UV-Kits</h2>
            </Card.Header>
            <Card.Body>
              <div className="text-center py-5">
                <h3>UV-Kits Page</h3>
                <p className="text-muted">
                  This page will contain the UV-kits functionality.<br />
                  Currently under development.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </main>
  );
};

export default UVKitsPage;